import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import axios from 'axios'
import Constant from '../../Constant'
import Toggle from 'react-toggle'
import ActivitiesController from '../../common/activitiesController/ActivitiesController'
class DestinationList extends React.Component {
  state = {
    Products_data: [],
    isloading: false,
    cat: this.props.match.params.boatType,
  }

  handleStatusChange = async (id, isActive, key) => {
    var data = {
      destination_id: id,
      [key]: isActive,
    }

    await axios
      .put(Constant.getAPI() + '/cruise/update-cruise-destination-status', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Updated !', 'Status has been Changed', 'success')
          this.dashbord()
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  deleteDestination = (id) => {
    var cruiseId = this.props.match.params.boatId
    var data = {
      destination_id: id,
      cruise_id: cruiseId,
    }
    Swal.fire({
      title: 'Are you sure?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `No`,
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(Constant.getAPI() + '/cruise/delete-cruise-destination-v2', {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
              country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
            data,
          })
          .then(() => {
            Swal.fire({
              title: 'Destination Deleted Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
            this.dashbord()
          })
          .catch((err) => {
            this.setState({ isData: false })
            if (err?.response?.status === 401) {
              Constant.getAuthLogout()
            } else {
              Swal.fire({
                title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
                icon: 'error',
                text: '',
                type: 'error',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
              })
            }
          })
      } else if (result.isDenied) {
        Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  componentDidMount() {
    this.dashbord()
  }

  dashbord = async () => {
    this.setState({ isloading: true })
    var cruiseId = this.props.match.params.boatId

    await axios
      .get(Constant.getAPI() + `/cruise/list-cruise-destinations/${cruiseId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            isloading: false,
            Products_data: res.data.data,
          })
        }
      })
      .catch((err) => {
        this.setState({ isloading: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    const columns = [
      {
        name: 'id',
        label: 'id',
        options: {
          filter: false,
          sort: false,
          display: false,
        },
      },
      {
        name: 'book_by',
        label: 'Book By',
        options: {
          customBodyRender: (value) => {
            return <div>{String(value).toUpperCase()}</div>
          },
        },
      },
      {
        name: 'destination_min_hour',
        label: 'Destination Hour',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (destination_min_hour, tableMeta) => {
            return tableMeta.rowData[1] == 'hours' ? <div>{destination_min_hour} Hour</div> : '--'
          },
        },
      },
      {
        name: 'destination_address_en',
        label: `Destination Address: English`,
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'destination_address_ar',
        label: `Destination Address: Arabic`,
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'destination_lat',
        label: `Latitude`,
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'destination_long',
        label: 'Longitude',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'price',
        label: `Sunday Price`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => <div>{value >= 0 ? value : '--'}</div>,
        },
      },
      {
        name: 'monday_price',
        label: `Monday Price`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => <div>{value >= 0 ? value : '--'}</div>,
        },
      },
      {
        name: 'tuesday_price',
        label: `Tuesday Price`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => <div>{value >= 0 ? value : '--'}</div>,
        },
      },
      {
        name: 'wednesday_price',
        label: `Wednesday Price`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => <div>{value >= 0 ? value : '--'}</div>,
        },
      },
      {
        name: 'thursday_price',
        label: `Thursday Price`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => <div>{value >= 0 ? value : '--'}</div>,
        },
      },
      {
        name: 'friday_price',
        label: `Friday Price`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => <div>{value >= 0 ? value : '--'}</div>,
        },
      },
      {
        name: 'saturday_price',
        label: `Saturday Price`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => <div>{value >= 0 ? value : '--'}</div>,
        },
      },
      {
        name: 'is_flash_offer',
        label: 'Flash Offer',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (is_active, tableMeta) => {
            return (
              <Toggle
                checked={is_active === true ? true : false}
                value={is_active}
                onChange={this.handleStatusChange.bind(this, tableMeta.rowData[0], !is_active, 'is_flash_offer')}
              />
            )
          },
        },
      },
      {
        name: 'is_active',
        label: 'Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (is_active, tableMeta) => {
            return (
              <Toggle
                checked={is_active === true ? true : false}
                value={is_active}
                onChange={this.handleStatusChange.bind(this, tableMeta.rowData[0], !is_active, 'is_active')}
              />
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          display: true,
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div className="d-flex align-items-center">
                <Link
                  to={
                    `/boatsmaster/${this.props.match.params.boatType}/${this.props.match.params.boatId}/destination-add/` +
                    id
                  }
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                </Link>
                <span
                  onClick={this.deleteDestination.bind(this, id)}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Delete"
                >
                  <i className="f-20 icofont icofont-delete-alt text-danger"></i>{' '}
                </span>
                <ActivitiesController refId={id}>Activities</ActivitiesController>
              </div>
            )
          },
        },
      },
    ]
    const options = {
      filterType: true,
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Products Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>{this.props.match.params.boatType} Destination List</h4>
                    </div>
                  </div>
                  <Link
                    to={`/boatsmaster/${this.props.match.params.boatType}/${this.props.match.params.boatId}/destination-add`}
                    className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                    data-modal="modal-13"
                  >
                    {' '}
                    <i className="icofont icofont-plus m-r-5"></i>
                    {this.props.match.params.boatType} Destination Add
                  </Link>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link
                          to={`/viewboat-details/${this.props.match.params.boatType}/${this.props.match.params.boatId}`}
                        >
                          {this.props.match.params.boatType} Details{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">{this.props.match.params.boatType} Destination List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        {this.state?.isloading ? (
                          'loading...'
                        ) : (
                          <MUIDataTable
                            title={`${this.props.match.params.boatType} Destination List`}
                            className="table-responsive"
                            data={this.state.Products_data}
                            columns={columns}
                            options={options}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default DestinationList
